"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PositionLesson = function PositionLesson(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-sm-12 col-md-4 col-lg-4 cards positionLess positionLessonFont",
    style: {
      padding: '15px,0'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row respPadding",
    style: {
      margin: '0'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-11 col-sm-11 col-md-11 col-lg-11 positions",
    style: {
      padding: '0',
      paddingBottom: '10px'
    }
  }, "The importance of position"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-1 col-sm-1 col-md-1 col-lg-1 displayUptoTab",
    style: {
      color: '#ccc',
      padding: '0'
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-arrow-left arrowSize",
    onClick: props.learnPositionsFun,
    style: {
      "float": 'right'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: {
      paddingTop: '7.04px',
      margin: '0'
    }
  }, "Table position is often the difference between winning and losing a hand. Always be aware of your position relative to the dealer button. The later you act in a hand the better your position, with more information than the players sitting before you and can adjust your strategy accordingly."), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '10.14px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "What is Early Position?")), /*#__PURE__*/_react["default"].createElement("div", null, "In a 6max table the first two seats on the left of the BB: UTG (Under the Gun) and UTG + 1. These are the first to act preflop, and will act immediately after the blinds (SB and BB) postflop"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: {
      margin: '0',
      paddingTop: '10.84px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-5 col-sm-4 col-md-4 col-lg-4"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "//" + props.domain + "/images/common/missions/tablePositions/early.png",
    height: "100px",
    width: "100px"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 col-sm-7 col-md-7 col-lg-7",
    style: {
      paddingTop: '2px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '7px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "UTG - Under the gun")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '7px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "UTG +1 - Under the gun +1")))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '13.15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "What is Late Position?")), /*#__PURE__*/_react["default"].createElement("div", null, "In a 6max table BTN and CO are considered late position. Preflop, the last player to act will be the SB and for this reason he should open a wide range, but postflop SB will be the first to act and will have the positional disadvantage of acting first."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: {
      margin: '0',
      paddingTop: '10.08px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-5 col-sm-4 col-md-4 col-lg-4"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "//" + props.domain + "/images/common/missions/tablePositions/late.png",
    height: "100px",
    width: "100px"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 col-sm-7 col-md-7 col-lg-7",
    style: {
      paddingTop: '18px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, "SB - Small Blind")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '7px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "TB - The Button")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: '7px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, "CO - Cut Off")))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: '/reportCardCourse/Position Part-1',
    target: props.isLiveview ? "_blank" : "_self"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    "data-e2e": "fullPositionLesson",
    className: "beginMission positionLesson"
  }, "SEE FULL POSITION LESSON"))));
};
var _default = PositionLesson;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/Missions/PositionLesson.js
 ** module id = 2379
 ** module chunks = 0
 **/